import { useCallback, useContext } from "react";

import { useParams } from "react-router-dom";

import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import {
  CMP_ORDER_URL,
  CMP_PATIENTS_REPORT_TAB_URL,
  CMP_PATIENTS_TEST_RESULT_URL,
  getCmpUrl
} from "@/core/urls";
import { ViewerContext } from "@/tpo/Viewer";
import { useQuery } from "@apollo/client";

import { PATIENT_ENTITLEMENTS_QUERY, REPORTS_LIST_QUERY } from "../reports/graphql/queries";

export default function usePatientTestsAndReports() {
  const { userId } = useContext(ViewerContext);
  const { organisation, organisationId } = useOrganisationContext();
  const { patientId } = useParams();

  const getOrderUrl = useCallback(
    orderId =>
      getCmpUrl(CMP_ORDER_URL, {
        organisationId: organisation.hashId,
        orderId,
        patientId
      }),
    [organisation, patientId]
  );

  const getTestResultUrl = useCallback(
    userTestId =>
      getCmpUrl(CMP_PATIENTS_TEST_RESULT_URL, {
        organisationId: organisation.hashId,
        userTestId,
        patientId
      }),
    [organisation, patientId]
  );

  const getReportUrl = useCallback(
    report =>
      getCmpUrl(CMP_PATIENTS_REPORT_TAB_URL, {
        organisationId: organisation.hashId,
        patientId,
        reportSlug: report.slug,
        tab: "overview"
      }),
    [organisation, patientId]
  );

  const { data: reportsData } = useQuery(REPORTS_LIST_QUERY, {
    variables: {
      userId,
      organisationId: organisation?.id
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip: !organisationId || !userId
  });

  const { data: entitlementsData } = useQuery(PATIENT_ENTITLEMENTS_QUERY, {
    variables: {
      userId,
      organisationId: organisation?.id
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip: !organisationId || !userId
  });

  return {
    getOrderUrl,
    getTestResultUrl,
    getReportUrl,
    reports: reportsData?.reports,
    userReports: reportsData?.userReports,
    userEntitlements: entitlementsData?.user?.entitlements,
    reportViewType: "patient"
  };
}
